import { DELETE } from "../API"


export const deleteMessageForConversationAPi = (conversationId, messageId, onSuccess, onError) => {

    DELETE(`/api/v1/chat/conversations/${conversationId}/messages/${messageId}`, onSuccess, onError)
}